<script>
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useLearningPathStore } from "@/stores/learning-path-store";
import { useEnrollmentStore } from "@/stores/access/enrollment-store";
import { useAuthStore } from "@/stores/auth-store";

export default {
  components: { BaseLoading },

  data() {
    return {
      sharedStore: useSharedStore(),
      learningPathStore: useLearningPathStore(),
      enrollmentStore: useEnrollmentStore(),
      authStore: useAuthStore(),
    };
  },

  async mounted() {
    const studentId = this.authStore.currentUser?.id;
    await Promise.all([
      this.learningPathStore.fetchStudentPaths(),
      studentId
        ? this.enrollmentStore.fetchEnrollmentStudentList(studentId)
        : Promise.resolve(),
    ]);
  },

  methods: {
    isCourseCompleted(item) {
      if (item.is_completed) return true;
      return this.enrollmentStore.enrollmentStudent.some(
        (e) =>
          (e.courseID?.course_id === item.course || e.courseID === item.course) &&
          e.status === "Completed"
      );
    },
  },
};
</script>

<template>
  <layouts-header></layouts-header>

  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">My Learning Paths</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                My Learning Paths
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <student-header></student-header>
      <div class="row">
        <student-sidebar></student-sidebar>

        <div class="col-lg-9">
          <!-- Page Title -->
          <div class="page-title mb-3">
            <h5 class="fw-bold mb-0">My Learning Paths</h5>
          </div>

          <!-- Empty State -->
          <div
            v-if="learningPathStore.studentPaths.length === 0 && !sharedStore.loading"
            class="border rounded-2 p-4 mb-3 text-center"
          >
            <div class="d-inline-flex icon-box bg-soft-info mb-3">
              <img src="@/assets/img/icon/bookmark.svg" alt="" />
            </div>
            <h6 class="mb-1">Belum ada Learning Path untukmu</h6>
            <p class="mb-0 fs-14 text-gray-5">
              Saat instructor meng-assign kamu ke learning path, jalur
              pembelajaran akan muncul di sini.
            </p>
          </div>

          <!-- Learning Path Cards -->
          <div
            v-for="path in learningPathStore.studentPaths"
            :key="path.id"
            class="card mb-3 border-0 shadow-sm"
          >
            <div class="card-body">
              <!-- Header -->
              <div class="mb-3">
                <h6 class="fw-bold mb-1">{{ path.title }}</h6>
                <p class="text-muted fs-13 mb-0" v-if="path.note">{{ path.note }}</p>
              </div>

              <!-- Course List -->
              <div class="border rounded-2 p-3">
                <p class="fw-medium fs-13 text-muted mb-2">
                  <i class="isax isax-book-1 me-1"></i>
                  Course dalam Path ({{ path.item_count }})
                </p>
                <div
                  v-for="item in path.items"
                  :key="item.id"
                  class="d-flex align-items-center justify-content-between py-2 border-bottom"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="badge bg-primary me-3 fw-bold"
                      style="min-width: 28px;"
                    >
                      {{ item.order }}
                    </span>
                    <span class="fs-14 fw-medium">{{ item.course_title }}</span>
                  </div>
                  <router-link
                    v-if="!isCourseCompleted(item)"
                    :to="{ name: 'CourseDetail', params: { course_id: item.course } }"
                    class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                  >
                    <i class="isax isax-play-circle me-1"></i> Mulai
                  </router-link>
                  <span
                    v-else
                    class="badge bg-success-subtle text-success border border-success d-inline-flex align-items-center px-2 py-1 fs-12"
                  >
                    <i class="isax isax-tick-circle me-1"></i> Selesai
                  </span>
                </div>
                <div
                  v-if="!path.items || path.items.length === 0"
                  class="text-muted fs-13 text-center py-2"
                >
                  Belum ada course ditambahkan.
                </div>
              </div>
            </div>
          </div>
          <!-- /Learning Path Cards -->
        </div>
      </div>
    </div>
  </div>

  <BaseLoading v-show="sharedStore.loading"></BaseLoading>
</template>
